import { lazy } from 'react';
import { SearchIcon } from '@tools/luci-ui';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/activity-agent';

const MainView = lazy(
  () =>
    import(/* webpackChunkName: "ActivityAgentRoutes" */ '../pages/MainView')
);

export const activityAgentRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Activity Agent',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: SearchIcon,
      pages: []
    }
  ]
};
